import React from 'react';
import { trackCheckoutStart } from '../lib/metaPixel';

/** The single checkout every purchase button leads to. */
export const CHECKOUT_URL = 'https://naileducatorready.impultienda.ar/checkout';

/** Anchor of the final block, where the only checkout button lives. */
export const CHECKOUT_ANCHOR = '#checkout';
export const CURRENCY_NOTE = 'Payments are processed in your local currency';
interface CtaButtonProps {
  label: string;
  /** 'checkout' opens the checkout; 'scroll' moves down to the checkout block. */
  action?: 'checkout' | 'scroll';
  className?: string;
}
export function CtaButton({
  label,
  action = 'scroll',
  className = ''
}: CtaButtonProps) {
  const isCheckout = action === 'checkout';
  return <a href={isCheckout ? CHECKOUT_URL : CHECKOUT_ANCHOR} onClick={isCheckout ? trackCheckoutStart : undefined} className={`group inline-flex items-center justify-center gap-2.5 rounded-[12px] bg-brand-cta px-8 py-4 font-body text-[13px] font-semibold uppercase tracking-[0.08em] text-brand-cta-text shadow-[0_14px_30px_-14px_rgba(72,103,70,0.7)] transition-[background-color,transform] duration-200 ease-out hover:bg-brand-cta-dark active:scale-[0.98] focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-cta focus-visible:ring-offset-2 focus-visible:ring-offset-brand-ivory sm:text-sm ${className}`} data-id="element-1" data-mp="vcbp4gpfuaen">
      <span data-id="element-2" data-mp="3juuh4llszv70">{label}</span>
      <span aria-hidden="true" className="text-base font-normal transition-transform duration-200 ease-out group-hover:translate-x-1" data-id="element-3" data-mp="3owa10ac8vvnt">
        →
      </span>
    </a>;
}
interface CtaBlockProps {
  label: string;
  /** Small line above the button, e.g. what is included. */
  meta?: string;
  /** Only the final checkout block shows the price. */
  action?: 'checkout' | 'scroll';
  className?: string;
}

/**
 * Centered call-to-action block. Every block carries the local-currency note;
 * only the final checkout block shows the price.
 */
export function CtaBlock({
  label,
  meta,
  action = 'scroll',
  className = ''
}: CtaBlockProps) {
  const isCheckout = action === 'checkout';
  return <div className={`flex flex-col items-center text-center ${className}`} data-id="element-4" data-mp="3hyw1gx8ln3xe">
      {meta && <p className="mb-3 font-body text-[11px] uppercase tracking-[0.18em] text-brand-charcoal/50" data-id="element-5" data-mp="iea1wk6887o">
          {meta}
        </p>}
      {isCheckout && <>
          <p className="font-body text-[13px] uppercase tracking-[0.16em] text-brand-charcoal/45" data-id="element-6" data-mp="9ikj968u6m11">
            Regular Value <span className="line-through decoration-brand-charcoal/35" data-id="element-7" data-mp="4jpza0z4urfc">$97</span>
          </p>
          <p className="mt-2 mb-3 font-body text-[2.75rem] font-bold leading-none tracking-[-0.01em] text-brand-charcoal" data-id="element-8" data-mp="jggsttm4l8x1">
            27 USD
          </p>
        </>}
      <p className="font-body text-[11px] uppercase tracking-[0.14em] text-brand-charcoal/50" data-id="element-9" data-mp="efkmzai7rcoz">
        {CURRENCY_NOTE}
      </p>
      <CtaButton label={label} action={action} className="mt-4 w-full sm:w-auto" data-id="element-10" data-mp="2g9a7w76dpkvg" />
    </div>;
}